import { schema } from 'normalizr';
import { questionSchema, matrixQuestionSchema } from './questionSchemas';

function schemaMapper(question) {
  switch (question.type) {
    case 'Question':
      return 'questions';
    case 'MatrixQuestion':
      return 'matrixQuestions';
    default:
      return question.type;
  }
}

export const questionBlockSchema = new schema.Entity('questionBlocks', {
  questions: new schema.Array(
    {
      questions: questionSchema,
      matrixQuestions: matrixQuestionSchema,
    },
    schemaMapper
  ),
});



// WEBPACK FOOTER //
// ./src/schema/survey/index.js